export default import.meta.ROLLUP_FILE_URL_hpMosloMzfOQjatTh_jvsA